export default function clean_blank_file_input(form: any): void {
  for (const element of form.elements) {
    if (element.type === "file" && element.value === "") {
      element.parentNode.removeChild(element);
    }
  }
  return form;
}
